export const ADD_NEW = "ADD_NEW";
export const DELETE = "DELETE";
export const EDIT = "EDIT";
export const GET_ALL = "GET_ALL";

export const TURN_ADD_ON = "TURN_ADD_ON";
export const TURN_ADD_OFF = "TURN_ADD_OFF";

export const TURN_EDIT_OFF = "TURN_EDIT_OFF";
export const TURN_EDIT_ON = "TURN_EDIT_ON";

export const TURN_SEARCH_OFF = "TURN_SEARCH_OFF";
export const TURN_SEARCH_ON = "TURN_SEARCH_ON";

export const TURN_SORT_OFF = "TURN_SORT_OFF";
export const TURN_SORT_ON = "TURN_SORT_ON";
export const SORT_TITLE_ASC = "SORT_TITLE_ASC";
export const SORT_TITLE_DESC = "SORT_TITLE_DESC";
export const SORT_DATE_ASC = "SORT_DATE_ASC";
export const SORT_DATE_DESC = "SORT_DATE_DESC";

export const ADD_MESSAGE = "ADD_MESSAGE";
export const CLOSE_MESSAGE = "CLOSE_MESSAGE";
export const CLOSE_ALL_MESSAGES = "CLOSE_ALL_MESSAGES";

export const ADD_ID_TO_COFIRM_REMOVE = "ADD_ID_TO_COFIRM_REMOVE";